<template>
    <div ref="monthlyChart" style="width: 100%;height:400px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'MonthlyTraffic',
    data() {
        return {
            chartInstance: null,
        }
    },
    props: ['monthlyData', 'trafficUnitMonthly'],
    methods: {
        initChart() {
            const chartDom = this.$refs.monthlyChart;
            if (chartDom) {
                if (this.chartInstance) {
                    this.chartInstance.dispose();
                }
                this.chartInstance = echarts.init(chartDom);
                this.updateChart();
            } else {
                console.error('error');
            }
        },
        updateChart() {
            if (this.chartInstance && this.monthlyData) {
                var data = this.monthlyData.map(item => {
                    let value = item.Sum;
                    switch (this.trafficUnitMonthly) {
                        case 'M':
                            value *= 1000;
                            break;
                        case 'G':
                            value;
                            break;
                        case 'T':
                            value /= 1000;
                            break;
                        default:
                            break;
                    }
                    return [item.Timestamp, value.toFixed(2)];
                });
                var option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'cross' }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'time',
                        name: 'time',
                        splitLine: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: 'value',
                        name: this.trafficUnitMonthly,
                        axisLabel: {
                            formatter: '{value} ' + this.trafficUnitMonthly
                        }
                    },
                    series: [{
                        name: 'Traffic',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        data: data,
                        label: {
                            show: false,
                            position: 'top',
                            fontSize: 10
                        }
                    }]
                };
                this.chartInstance.setOption(option, true);
            } else {
                console.error('month instance error');
            }
        },
    },
    watch: {
        monthlyData(newData) {
            if (newData && newData.length > 0) {
                this.initChart();
            }
        },
        trafficUnitMonthly(newUnit, oldUnit) {
            if (newUnit !== oldUnit) {
                this.updateChart();
            }
        },
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
        }
    }

}
</script>
